<template>
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.91749 0.787109L9.35163 1.3034C8.20816 2.3484 6.63083 2.47402 5.31747 1.7272L4.65099 1.34757C3.35985 0.614553 1.81257 0.624216 0.671708 1.62643L0 2.21726V5.53035L0.659946 4.94642C1.7995 3.93869 3.3507 3.92626 4.64315 4.66066L5.31877 5.04443C6.63083 5.78987 8.20686 5.66287 9.34902 4.61925L9.91618 4.1002V0.787109H9.91749Z"
      fill="white"
    />
    <path
      d="M9.91749 5.83146L9.35163 6.34775C8.20816 7.39275 6.63083 7.51837 5.31747 6.77155L4.65099 6.39192C3.36115 5.65752 1.81257 5.66718 0.671708 6.66939L0 7.26023V10.5733L0.659946 9.98938C1.7995 8.98165 3.3507 8.96923 4.64315 9.70363L5.31877 10.0874C6.63083 10.8328 8.20686 10.7058 9.34902 9.66222L9.91618 9.14317V5.83008L9.91749 5.83146Z"
      fill="white"
    />
  </svg>
</template>
